// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

type Props = HasProduct;

export interface Prop65WarningStyles {
    wrapperContainer?: InjectableCss;
    title?: TypographyPresentationProps;
    IconWrapper?: InjectableCss;
    subTitle?: TypographyPresentationProps;
    warningIcon?: IconPresentationProps;
    content?: TypographyPresentationProps;
}

export const prop65WarningStyles: Prop65WarningStyles = {};

const Prop65Warning: React.FC<Props> = ({ product }) => {
    const styles = prop65WarningStyles;

    if (!product || !product.properties?.prop65Warning) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapperContainer}>
            <Typography {...styles.title}>{translate("Prop 65 Warning")}</Typography>
            <StyledWrapper {...styles.IconWrapper}>
                <Icon {...styles.warningIcon} />
                <Typography {...styles.subTitle}>{translate("Warning")}</Typography>
            </StyledWrapper>
            <Typography {...styles.content}>{siteMessage("Custom_Prop65WarningContent")}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(Prop65Warning),
    definition: {
        displayName: "Prop 65 Warning",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
